import styled, { css } from 'styled-components';
import Image from '@klv/atoms/image';
import Grid from '@klv/utils/grid';

export const ImageContainer = styled.div`
  overflow: hidden;
  margin-bottom: 1.4rem;
  pointer-events: none;
  
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      margin-bottom: 1.2rem;
      grid-column: 1/-1;
      align-self: end;
    } 
  `}
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  transition: all .3s ease-in-out;
  display: block;
  line-height: 0;
`;

export const TextContainer = styled.div`
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      grid-column: 1/-1;
      align-self: end;
      min-height: 11.4rem;
    }
  `}
`;

const baseText = css`
  font-size: 1.6rem;
  font-family: "Sohne";
  line-height: 1.4;
`;

export const Headline = styled.h3` 
  ${baseText}
  font-size: 1.8rem;
  font-weight: 500;

  ${({ theme }) => `
    color: ${theme.colors.charcoal};

    ${theme.screenSize.s1200.mediaQuery} {
      font-size: 2rem;
    }
  `}
`;

export const Text = styled.p`
  ${baseText}
`;


export const StyledFeatureCard = styled(Grid)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 0;
  
  ${({ theme }) => `
    ${theme.screenSize.s1024.mediaQuery} {
      display: grid;
      padding: 0;
      grid-column: span 6;
      align-self: end;
    }
    &:focus-visible {
      outline: 1px dashed ${theme.colors.charcoal};
      outline-offset: 2px;
      border-radius: 1.5rem;
    }
  `}
`;
